import { FC } from "react";
import { Spinner, Column } from "@hightouch/htui";

import { MarketingHome } from "./components/marketing";
import { useEntitlements } from "src/hooks/use-entitlement";
import { usePersistedState } from "src/hooks/use-persisted-state";
import { useUser } from "src/contexts/user-context";
import { ActivationHome } from "./components/activation";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import {
  NewPage,
  PageCardContent,
  PageCardHeader,
} from "src/components/layout/new-page";

// Prefetch lazy chart chunks so they load in parallel with data fetching
import("./components/activation/sync-health-charts").catch(() => {});
import("./components/marketing/metrics").catch(() => {});

export const Home: FC = () => {
  const { workspace } = useUser();
  const { data: entitlementsData } = useEntitlements(false, true);
  const { isPermitted: isWorkspaceAdmin, isLoading } = useResourcePermission({
    v2: { resource: "workspace", grant: "can_update" },
  });

  const isDefaultActivation =
    !entitlementsData.entitlements.audiences || isWorkspaceAdmin;

  const state = usePersistedState(
    `${workspace?.id}-home-view`,
    isDefaultActivation ? "activation" : "marketing",
  );

  if (!state.value || isLoading) {
    return (
      <NewPage title="Home">
        <PageCardHeader removeBoxShadow />
        <PageCardContent hasGradient variant="light">
          <Column align="center" justify="center" flex={1}>
            <Spinner />
          </Column>
        </PageCardContent>
      </NewPage>
    );
  }

  if (state.value === "marketing") {
    return <MarketingHome onToggleView={() => state.set("activation")} />;
  }

  return <ActivationHome onToggleView={() => state.set("marketing")} />;
};
